// extracted by mini-css-extract-plugin
module.exports = {"container":"BankAccount_container__ZXeyc","bank":"BankAccount_bank__hDAbL","buttonsContainer":"BankAccount_buttonsContainer__3Y76a"};